import { Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import MainLayout from './layouts/MainLayout'
import Login from './pages/Login'
import ProtectedRoute from './auth/ProtectedRoute'
import Dashboard from './pages/Dashboard'
import ProjectList from './pages/ProjectList'
import ProjectDetail from './pages/ProjectDetail'
import OutreachCenter from './pages/OutreachCenter'
import ReplyCenter from './pages/ReplyCenter'
import AccountManagement from './pages/AccountManagement'
import Settings from './pages/Settings'
import Statistics from './pages/Statistics'
import UserManagement from './pages/UserManagement'
import ScrapeCenter from './pages/ScrapeCenter'
import ConflictCenter from './pages/ConflictCenter'
import KanbanBoard from './pages/KanbanBoard'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* 公开路由 - 登录页 */}
        <Route path="/login" element={<Login />} />

        {/* 受保护的路由 - 需要登录 */}
        <Route path="/" element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="projects" element={<ProjectList />} />
          <Route path="projects/:id" element={<ProjectDetail />} />
          <Route path="scrape" element={<ScrapeCenter />} />
          <Route path="outreach" element={<OutreachCenter />} />
          <Route path="kanban" element={<KanbanBoard />} />
          <Route path="replies" element={<ReplyCenter />} />
          <Route path="accounts" element={<AccountManagement />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="users" element={
            <ProtectedRoute requireAdmin>
              <UserManagement />
            </ProtectedRoute>
          } />
          <Route path="conflicts" element={
            <ProtectedRoute requireAdmin>
              <ConflictCenter />
            </ProtectedRoute>
          } />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </QueryClientProvider>
  )
}

export default App
